import * as React from "react";
import Svg, { Path } from "react-native-svg";

export const NoteIcon: React.FC<{
  color?: string;
  size?: 40 | 32 | 24 | 16 | 12;
}> = ({ color = "#000", size = 40 }) => {
  return (
    <Svg
      width={((size * 1) / 42) * 25}
      height={size}
      viewBox="0 0 25 42"
      fill="none"
    >
      <Path
        d="M4.80651 40.68C3.48384 40.68 2.48117 40.36 1.79851 39.72C1.11584 39.0373 0.774506 38.1627 0.774506 37.096C0.774506 35.944 1.09451 34.8773 1.73451 33.896C2.41717 32.872 3.29184 32.0613 4.35851 31.464C5.42517 30.8667 6.53451 30.568 7.68651 30.568C8.19851 30.568 8.71051 30.632 9.22251 30.76C9.77717 30.8453 10.3105 30.9947 10.8225 31.208V0.104004H13.1905V3.75201C13.6172 4.43467 14.0865 5.09601 14.5985 5.73601C15.1532 6.33334 15.6865 6.93067 16.1985 7.52801C17.1798 8.59467 18.1185 9.74667 19.0145 10.984C19.9105 12.2213 20.6358 13.6507 21.1905 15.272C21.7878 16.8933 22.0865 18.8133 22.0865 21.032C22.0865 24.9573 20.9985 28.4987 18.8225 31.656H17.2225C17.9478 29.992 18.4812 28.392 18.8225 26.856C19.1638 25.2773 19.3345 23.8267 19.3345 22.504C19.3345 19.7307 18.6945 17.5547 17.4145 15.976C16.1345 14.3547 14.7265 13.3093 13.1905 12.84V31.4C13.1905 33.2347 12.7852 34.856 11.9745 36.264C11.2065 37.6293 10.1825 38.7173 8.90251 39.528C7.66517 40.296 6.29984 40.68 4.80651 40.68Z"
        fill={color}
      />
    </Svg>
  );
};
